// @ts-check

const initDashboardState = () => ({
  notificationsAmount: null
})

/** @type {import('vuex').MutationTree<ReturnType<initDashboardState>>} */
const dashboardMutations = {
  clearAllData: (state) => {
    Object.assign(state, initDashboardState())
  },
  setNotificationsAmount: (state, amount) => {
    state.notificationsAmount = amount
  }
}

/** @type {import('vuex').ActionTree<ReturnType<typeof initDashboardState>, RootState>} */
const dashboardActions = {
  async init({ dispatch }) {
    await dispatch('subscription/getCard', null, { root: true })
  }
}

export const dashboardModule = {
  namespaced: true,
  state: initDashboardState,
  mutations: dashboardMutations,
  actions: dashboardActions
}

export default dashboardModule
